import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { isOAuthProtectedResource } from './oauth-resource-server.config';

export const oauthTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const oauthService = inject(OAuthService);
  const token = oauthService.getAccessToken();

  if (!token || req.headers.has('Authorization') || !isOAuthProtectedResource(req.url)) {
    return next(req);
  }

  return next(req.clone({
    setHeaders: { Authorization: 'Bearer ' + token },
  }));
};
